export default "__VITE_ASSET__DACP3ppT__"